import React from "react";
import Header from "../../components/Header/Header";
import Intro from "../../sections/Intro/Intro";
import Included from "./Included";
import Footer from "../../components/Footer/Footer";

import Reviews from "../../sections/Reviews/Reviews";
import Pricing from "./Pricing";

const Payroll = () => {
  return (
    <div className="column">
      <Header />
      <Intro
        primary="Pay your people on time, every time."
        secondary="Compliant payroll processing for businesses that take their reputation seriously."
      />

      <Included />

      <Pricing />

      <Footer background />
    </div>
  );
};

export default Payroll;
